export const SEOUL_REGION_CODE = '11';
export const DEFAULT_NEIGHBORHOOD_CATEGORY_KEYWORD = '소아과';

export const DEFAULT_HAIR_LOSS_TREATMENT_MEDICINE_UNIT_ID = '73';
export const DEFAULT_DIET_TREATMENT_MEDICINE_UNIT_ID = '185';
export const DEFAULT_ACNE_TREATMENT_MEDICINE_UNIT_ID = '10';
